import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import { faqs, faqUpdatedOn, getFaqAnswerParagraphs, getFaqParagraphParts } from '../../data/faqData'

const LandingFaqAccordion = () => {
  const [openIndex, setOpenIndex] = useState(null)

  const toggle = (index) => {
    setOpenIndex((prev) => (prev === index ? null : index))
  }

  return (
    <div className="landing-faq" aria-label="Frequently Asked Questions">
      <h2 className="landing-faq-title">Frequently Asked Questions</h2>
      <p className="landing-faq-updated">Updated {faqUpdatedOn}</p>
      <div className="landing-faq-accordion">
        {faqs.map((item, index) => {
          const isOpen = openIndex === index
          const panelId = `landing-faq-panel-${index}`
          const headerId = `landing-faq-header-${index}`

          return (
            <div
              key={item.q}
              className={`landing-faq-item${isOpen ? ' landing-faq-item--open' : ''}`}
            >
              <button
                type="button"
                id={headerId}
                className="landing-faq-question"
                aria-expanded={isOpen}
                aria-controls={panelId}
                onClick={() => toggle(index)}
              >
                <span className="landing-faq-question-text">
                  <span className="landing-faq-question-number">{index + 1}.</span>
                  <span className="landing-faq-question-label">{item.q}</span>
                </span>
                <span className="landing-faq-chevron" aria-hidden="true" />
              </button>
              <div
                id={panelId}
                role="region"
                aria-labelledby={headerId}
                className="landing-faq-answer-wrap"
                hidden={!isOpen}
              >
                <div
                  className={`landing-faq-answer${item.spacedParagraphs ? ' landing-faq-answer--spaced' : ''}`}
                >
                  {getFaqAnswerParagraphs(item).map((paragraph, pIndex) => (
                    <p key={pIndex}>
                      {getFaqParagraphParts(paragraph).map((part, partIndex) => {
                        if (typeof part === 'string') return part
                        if (part.to)
                          return (
                            <Link key={partIndex} to={part.to} className="landing-faq-link">
                              {part.text}
                            </Link>
                          )
                        return (
                          <strong
                            key={partIndex}
                            style={{ fontWeight: part.bold === 'heavy' ? 800 : 600 }}
                          >
                            {part.text}
                          </strong>
                        )
                      })}
                    </p>
                  ))}
                </div>
              </div>
            </div>
          )
        })}
      </div>
    </div>
  )
}

export default LandingFaqAccordion
